import { getAPI , postAPI } from "../../api";
import { REACT_APP_CUSTOMER , REACT_APP_JOB } from "../../utils/common";


export async function getPostPositions(){
    const Details = getAPI( REACT_APP_CUSTOMER + '/customer-list')
    return Details
}

export async function submitValues(data: any){
    const Details = postAPI(REACT_APP_JOB + `/position`, data)
    return Details
}
